import { Button, Flex, Form, Input, Typography } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useUpdateUser } from '../../../api/auth/auth-hooks';
import { jwtDecode } from 'jwt-decode';
import Cookies from 'js-cookie';

export default function NameForm({ data, closeModal, refretch }) {
    const { mutate } = useUpdateUser();
    const decoded = jwtDecode(Cookies.get('token'));
    const [form] = useForm();

    const onSubmit = () => {
        mutate(
            {
                fullName: form.getFieldValue('fullName'),
                lastName: form.getFieldValue('lastName'),
                email: '',
                iin: '',
                cityName: '',
                filialId: '',
                street: '',
                house: '',
                phone: '',
                userId: decoded.id,
            },
            {
                onSuccess: () => {
                    closeModal();
                    refretch();
                },
            },
        );
    };

    return (
        <>
            <Typography.Title
                level={3}
                style={{ color: '#100E71', fontFamily: 'Roboto, san-serif', fontWeight: '600' }}
            >
                ФИО
            </Typography.Title>

            <Form form={form} style={{ padding: '0', marginTop: '20px' }}>
                <Flex gap="50px">
                    <Form.Item name="fullName" style={{ width: '100%' }}>
                        <Input className={'input-style'} placeholder="Имя" />
                    </Form.Item>
                </Flex>
            </Form>
            <Form form={form} style={{ padding: '0', marginTop: '20px' }}>
                <Flex gap="50px">
                    <Form.Item name="lastName" style={{ width: '100%' }}>
                        <Input className={'input-style'} placeholder="Фамилия" />
                    </Form.Item>
                </Flex>
            </Form>
            <Flex justify="center">
                <Button className={'button-style'} onClick={onSubmit}>
                    Изменить
                </Button>
            </Flex>
        </>
    );
}
